<div class="w-full text-[18px] py-[10px] max-w-7xl mx-auto">
  <div class="flex items-center justify-between mb-4">
    <div class="font-medium text-[32px] text-amber-900">OOTB Entities</div>
    <button
      class="bg-amber-600 hover:bg-amber-700 rounded-md text-white py-[10px] px-[15px] cursor-pointer shadow-sm transition-all duration-300 font-medium flex items-center gap-2"
      (click)="createEntity()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      Add OOTB Entity
    </button>
  </div>

  <!-- List -->
  <div *ngIf="!createEntityFlag">
    <div *ngIf="entityList.length; else emptyState" class="grid grid-cols-1 gap-3">
      <div
        *ngFor="let entity of entityList"
        class="bg-white rounded-lg shadow-sm border border-amber-100 p-4 flex items-center justify-between cursor-pointer"
        (click)="viewEntity(entity)"
      >
        <div class="min-w-0">
          <div class="text-lg font-semibold text-gray-900 truncate">{{ entity.name }}</div>
          <div class="text-sm text-gray-500">{{ entity.type }} • {{ entity.data.length || 0 }} fields</div>
        </div>

        <button
          class="bg-amber-100 hover:bg-amber-200 text-amber-900 rounded-md px-3 py-2 text-sm font-medium transition-all duration-200"
          (click)="viewEntity(entity); $event.stopPropagation()"
        >
          View
        </button>
      </div>
    </div>

    <ng-template #emptyState>
      <div class="mt-6 p-10 bg-white rounded-lg text-center shadow-sm border border-dashed border-amber-200">
        <div class="text-xl font-medium text-amber-900 mb-2">No OOTB Entities</div>
        <div class="text-gray-500 mb-6">Add a new OOTB entity to get started</div>
        <button
          class="bg-amber-600 hover:bg-amber-700 rounded-md text-white py-[10px] px-[15px] cursor-pointer shadow-sm transition-all duration-300 font-medium inline-flex items-center gap-2 mx-auto"
          (click)="createEntity()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Add OOTB Entity
        </button>
      </div>
    </ng-template>
  </div>

  <!-- Editor (create/view) -->
  <div *ngIf="createEntityFlag">
    <app-ootb-entity [(entityData)]="newData" (exit)="exitEntity()"></app-ootb-entity>
  </div>
</div>
